/* eslint-disable camelcase */
import scanlineMapUtils from '../../../../mapUtils';
import { createIsValidReading, deriveDataSetsFromProps } from './_BASE';

export const createDerivedSurveys = (
	processedReadings,
	processedReadingsWithChartGaps,
	processedReadingsWithGeoGaps,
	type,
	surveyReadings,
	jobId,
	meta,
	isParentSurveyChecked,
	end_date,
	parent_survey_subtype,
	job_number
) => {
	const readings = {};
	const readingsWithChartGaps = {};
	const readingsWithGeoGaps = {};
	const readingsMap = {};
	const readingsGpsDistMap = {};
	const readingsIndexMap = {};
	const readingsWithChartGapsIndexMap = {};
	const readingsWithGeoGapsIndexMap = {};

	const series = {};
	const seriesIndexMap = {};
	const readingsPointIdIntegers = {};
	const readingsStationIdIntegers = {};

	const readingsMeta = {};
	const surveys = [];
	const { s3Key } = meta || {};

	const survey = scanlineMapUtils.createSurveyTemplate(type, 'AC', {
		primaryXAxis: {
			minimum: surveyReadings[0].gpsdistance,
			maximum: surveyReadings[surveyReadings.length - 1].gpsdistance
		},
		jobId,
		s3Key,
		end_date,
		parent_survey_subtype,
		job_number
	});
	scanlineMapUtils.initSurveyMeta(survey);
	survey.isDerived = true;
	const readingKeyProps = survey.meta.getReadingKeyProps();
	const isValidReading = createIsValidReading(readingKeyProps);

	if (processedReadings.filter(isValidReading).length) {
		const {
			readings: thisReadings,
			readingsIndexMap: thisReadingsIndexMap,
			readingsMap: thisReadingsMap,
			readingsGpsDistMap: thisReadingsGpsDistMap,
			readingsWithChartGaps: thisReadingsWithChartGaps,
			readingsWithChartGapsIndexMap: thisReadingsWithChartGapsIndexMap,
			readingsWithGeoGapsIndexMap: thisReadingsWithGeoGapsIndexMap,
			readingsWithGeoGaps: thisReadingsWithGeoGaps,
			series: thisSeries,
			seriesIndexMap: thisSeriesIndexMap,
			readingsPointIdIntegers: thisReadingsPointIdIntegers,
			readingsStationIdIntegers: thisReadingsStationIdIntegers
		} = deriveDataSetsFromProps(
			survey,
			readingKeyProps,
			processedReadings,
			processedReadingsWithChartGaps,
			processedReadingsWithGeoGaps,
			{ surveyMeta: survey.meta }
		);

		// add new AC survey
		if (isParentSurveyChecked) {
			const hasWarnings =
				thisSeries &&
				thisSeries.acWarning &&
				thisSeries.acWarning.filter(r => !r.isGap).length > 0;
			const hasProblems =
				thisSeries &&
				thisSeries.acProblem &&
				thisSeries.acProblem.filter(r => !r.isGap).length > 0;
			survey.checked = hasWarnings || hasProblems;
		} else {
			survey.checked = false;
		}

		readings[survey.id] = thisReadings;
		readingsWithChartGaps[survey.id] = thisReadingsWithChartGaps;
		readingsWithGeoGaps[survey.id] = thisReadingsWithGeoGaps;
		readingsIndexMap[survey.id] = thisReadingsIndexMap;
		readingsWithChartGapsIndexMap[
			survey.id
		] = thisReadingsWithChartGapsIndexMap;
		readingsWithGeoGapsIndexMap[survey.id] = thisReadingsWithGeoGapsIndexMap;
		readingsMap[survey.id] = thisReadingsMap;
		readingsGpsDistMap[survey.id] = thisReadingsGpsDistMap;
		series[survey.id] = thisSeries;
		seriesIndexMap[survey.id] = thisSeriesIndexMap;
		readingsMeta[survey.id] = meta;
		readingsPointIdIntegers[survey.id] = thisReadingsPointIdIntegers;
		readingsStationIdIntegers[survey.id] = thisReadingsStationIdIntegers;

		surveys.push(survey);
	}

	return {
		readings,
		readingsWithChartGaps,
		readingsWithGeoGaps,
		readingsMap,
		readingsGpsDistMap,
		readingsIndexMap,
		readingsWithChartGapsIndexMap,
		readingsWithGeoGapsIndexMap,
		readingsMeta,
		surveys,
		series,
		seriesIndexMap,
		readingsPointIdIntegers,
		readingsStationIdIntegers,
	};
};

export default { createDerivedSurveys };
